
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/introducing-sync-plugin",
      function () {
        return require("private-next-pages/blog/introducing-sync-plugin.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/introducing-sync-plugin"])
      });
    }
  